/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 * Ported element-for-element from mirror/index.html.
 * Nothing here is interpreted: every element, class and attribute is the
 * capture's own. The shared header, promo strip and footer are rendered around
 * this by SiteChrome; behaviour that needs JS comes from the interaction
 * components, not from rewriting this markup.
 */
import { Link } from 'react-router'
import { STUDIO_CTA_LABEL, STUDIO_SIGNUP_URL } from '@/content/studio'
import { trackEvent } from '@/lib/analytics/load'
import { HeroDots } from '@/components/marketing/HeroDots'
import { BottomCTA } from '@/components/sections/BottomCTA'
import { BeamLines } from '@/components/marketing/BeamLines'
import './css/home.css'

export default function HomePage() {
  return (
    <>
      <HeroDots />
      <BeamLines />
      <div className={"section-container dark home-hero-container"}>
        <div data-w-id={"7817e0a3-9e28-1655-d0a1-896aba538a4c"} style={{  }} className={"home-hero-wrapper maxwidthextralarge centeralign"}>
          <div className={"home-hero-header center maxwidthcontent"}>
            <div className={"div-block-88"}>
              <div className={"w-layout-vflex animated-border-box"}>
                <Link to={"/marketing-automation"} target={"_blank"} className={"link-block-13 w-inline-block"}>
                  <div className={"animated-border-container"}>
                    <p className={"animated-border-container-text"}>
                      AI Marketing Platform
                    </p>
                  </div>
                </Link>
                <div className={"w-embed"}>
                  <style>
                     .animated-border-container {"{"} width: fit-content; place-items: center; border-radius: 12px; {"}"} .animated-border-container:before {"{"} content: ''; pointer-events: none; animation: 14s infinite linear shine; position: absolute; padding: 1px; height: 100%; width: 100%; mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0); mask-composite: exclude !important; background-image: radial-gradient(transparent, transparent, #FDE5D9, #6866FF, #B2FEFE, transparent, transparent); background-size: 300% 300%; border-radius: 12px; box-sizing: border-box; will-change: background-position; aspect-ratio: 1 / 1; inset: 0; {"}"} @keyframes shine {"{"} 0% {"{"} background-position: 0 0; {"}"} 50% {"{"} background-position: 100% 100%; {"}"} 100% {"{"} background-position: 0 0; {"}"} {"}"} 
                  </style>
                </div>
              </div>
            </div>
            <h1 className={"center white pointer-events-auto nomargin"}>
              Send One Email;
              <br />
              Custom to Millions
            </h1>
            <div className={"maxwidthmedium"}>
              <div className={"large-text white center pointer-events-auto"}>
                AI-powered segmentation and 1:1 personalization for marketing messaging with 90% less manual work.
              </div>
            </div>
          </div>
          <div className={"w-layout-hflex button-lockup"}>
            <Link to={"/demo"} className={"button button-primary w-button"}>
              Book a demo
            </Link>
            <a href={STUDIO_SIGNUP_URL} className={"button button-outline w-button"} onClick={() => trackEvent('cta_click', { placement: 'home_hero', label: STUDIO_CTA_LABEL })}>
              {STUDIO_CTA_LABEL}
            </a>
          </div>
        </div>
        <div className={"div-block-83"} />
        {/* "Trusted by B2B marketing teams" — added to the live site after the
            Webflow capture was taken; recovered 2026-09-04. Live places it
            inside the hero, after div-block-83, on the dark surface. */}
        <div className={"w-layout-vflex section-wrapper stack center gap"}>
          <div className={"white mono-component-title"}>
            Trusted by B2B marketing teams
          </div>
          <div className={"client-logos _6"}>
            <img src={"/media/69af17d2100e16ae262eacbb_image 1 (1).png"} loading={"lazy"} alt="" className={"client-logo"} />
            <img src={"/media/69aed29e24083866c45e4943_brandlive.png"} loading={"lazy"} alt={"Brandlive"} className={"client-logo"} />
            <img src={"/media/69aed29e5be4edb2a233f95e_axonify.png"} loading={"lazy"} alt={"Axonify"} className={"client-logo"} />
            <img src={"/media/69b16ecebb9936945c98d1d9_tonic-logo-m.png"} loading={"lazy"} alt={"Tonic"} className={"client-logo"} />
            <img src={"/media/69aed29e8923249af9ef49de_questionpro.png"} loading={"lazy"} alt={"QuestionPro"} className={"client-logo"} />
            <img src={"/media/69aed29e515df4c2499ae619_goldcast.png"} loading={"lazy"} alt={"Goldcast"} className={"client-logo"} />
          </div>
        </div>
        <div className={"div-block-82"} />
      </div>
      <section className={"section-container"}>
        <div className={"div-block-81"} />
        <div className={"section-wrapper maxwidthlarge"}>
          <div className={"w-layout-blockcontainer container-22 w-container"}>
            <div className={"code-embed-13 w-embed w-iframe w-script"}>
              <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
                <iframe src={"https://player.vimeo.com/video/1104972394?title=0&portrait=0&byline=0&badge=0&autopause=0&player_id=0&app_id=58479"} frameBorder={"0"} allow={"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"} referrerPolicy={"strict-origin-when-cross-origin"} style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} title={"Singulate Demo V4"} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"client-logos-container section-container section-padding-full"}>
        <div className={"w-layout-vflex section-wrapper stack center gap"}>
          <div className={"mono-component-title"}>
            integrates with your EXISTING STACK
          </div>
          <div className={"client-logos _6"}>
            <img src={"/media/688c3919fa8c1caa83ab1bca_outreach.svg"} loading={"lazy"} width={"Auto"} height={"Auto"} alt="" id={"w-node-_91c619be-50ef-6db6-4c0f-818ad74e3b26-9ecbfc76"} className={"client-logo full-width"} />
            <img src={"/media/688c393364d23f99c0104fb1_heyreach.svg"} loading={"lazy"} width={"Auto"} height={"Auto"} alt="" id={"w-node-_91c619be-50ef-6db6-4c0f-818ad74e3b27-9ecbfc76"} className={"client-logo full-width"} />
            <img src={"/media/688c3959ee8adc4a9a30c8b6_instantly.svg"} loading={"lazy"} id={"w-node-_91c619be-50ef-6db6-4c0f-818ad74e3b28-9ecbfc76"} alt="" className={"client-logo full-width"} />
            <img src={"/media/688c3970491348d9b642e6c2_marketo.svg"} loading={"lazy"} id={"w-node-_91c619be-50ef-6db6-4c0f-818ad74e3b29-9ecbfc76"} alt="" className={"client-logo full-width"} />
            <img src={"/media/688c3990d1e409a52d62618b_hubspot.svg"} loading={"lazy"} width={"Auto"} height={"Auto"} alt="" id={"w-node-_91c619be-50ef-6db6-4c0f-818ad74e3b2a-9ecbfc76"} className={"client-logo full-width"} />
            <img src={"/media/688c39ee6f09a8557b489a84_zapier.svg"} loading={"lazy"} width={"Auto"} height={"Auto"} alt="" id={"w-node-_9f6a894b-ec1f-7afb-afb3-20f64a8e4c66-9ecbfc76"} className={"client-logo full-width"} />
          </div>
        </div>
      </section>
      <section className={"section-container section-padding gapextralarge"}>
        <div className={"section-wrapper stack center extrapaddingbottom"}>
          <h2 className={"center nomargin maxwidthlarge"}>
            AI-Native Marketing Ops
          </h2>
        </div>
        <div className={"section-wrapper"}>
          <div className={"w-layout-blockcontainer _50 w-container"}>
            <div className={"w-layout-vflex text-stack maxwidthsmall"}>
              <p className={"mono-component-title blue"}>
                DATA CLEANUP
              </p>
              <h3 className={"nomargin maxwidthsmall"}>
                Clean data on the fly
              </h3>
              <div className={"maxwidthsmall"}>
                Automatically clean and transform data tokens on the fly in your messaging. No spreadsheets, no manual cleanup. Just natural personalization.
              </div>
            </div>
          </div>
          <div className={"w-layout-blockcontainer _50 w-container"}>
            <div className={"div-block-72"}>
              <div className={"w-embed w-iframe"}>
                <div className={"video-wrapper"}>
                  <iframe className={"vimeo-bg"} src={"https://player.vimeo.com/video/1101884091?background=1"} frameBorder={"0"} allow={"autoplay; fullscreen; picture-in-picture"} allowFullScreen={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"section-container section-padding-full"}>
        <div className={"section-wrapper mobile-reverse"}>
          <div className={"w-layout-blockcontainer _50 w-container"}>
            <div className={"div-block-72"}>
              <div className={"w-embed w-iframe"}>
                <div className={"video-wrapper"}>
                  <iframe className={"vimeo-bg"} src={"https://player.vimeo.com/video/1101883974?background=1"} frameBorder={"0"} allow={"autoplay; fullscreen; picture-in-picture"} allowFullScreen={true} />
                </div>
              </div>
            </div>
          </div>
          <div className={"w-layout-blockcontainer _50 middle w-container"}>
            <div className={"w-layout-vflex text-stack maxwidthsmall"}>
              <p className={"mono-component-title blue"}>
                Segmentation
              </p>
              <h3 className={"nomargin maxwidthsmall"}>
                Create micro-audiences in seconds
              </h3>
              <div>
                Build precise audiences instantly without juggling lists or manually rewriting the same campaign across variants.
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"section-container section-padding extrapaddingbottom"}>
        <div className={"section-wrapper"}>
          <div className={"w-layout-blockcontainer _50 middle w-container"}>
            <div className={"w-layout-vflex text-stack maxwidthsmall"}>
              <p className={"mono-component-title blue"}>
                Generative Content
              </p>
              <h3 className={"nomargin maxwidthsmall"}>
                Deliver 1:1 verified messages that resonate
              </h3>
              <div>
                Go beyond surface-level tokens. Use AI and fine-tuning to create 1:1 content at scale that makes every contact feel seen and understood.
              </div>
            </div>
          </div>
          <div className={"w-layout-blockcontainer _50 w-container"}>
            <div className={"div-block-72"}>
              <div className={"w-embed w-iframe"}>
                <div className={"video-wrapper"}>
                  <iframe className={"vimeo-bg"} src={"https://player.vimeo.com/video/1101883912?background=1"} frameBorder={"0"} allow={"autoplay; fullscreen; picture-in-picture"} allowFullScreen={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"section-container section-padding-full dark back-side-dots"}>
        <div className={"section-wrapper stack"}>
          <div className={"w-layout-vflex flex-block-74"}>
            <div className={"w-layout-vflex text-stack center"}>
              <h2 className={"nomargin center white maxwidthlarge"}>
                Turn data into 1:1 engagement at scale
              </h2>
              <p className={"nomargin white center maxwidthsmall"}>
                Build beautiful, targeted campaigns that work with your existing tech stack. No siloed data or reporting.
              </p>
            </div>
            <div className={"code-embed-14 w-embed w-script"}>
              <div className={"beam-container"}>
                <svg className={"beam-lines"} />
                <div className={"beam-wrapper"} id={"beam-wrapper"}>
                  <div className={"left-icons"}>
                    <div className={"circle"} id={"drive"}>
                      <img src={"/media/6888bb6b7c9e937cebf660aa_keywords.png"} />
                    </div>
                    <div className={"circle"} id={"docs"}>
                      <img src={"/media/6888bba0232561d3a1dffcf8_jobtitle.png"} />
                    </div>
                    <div className={"circle"} id={"whatsapp"}>
                      <img src={"/media/6888bbbde91e2347c04d2b9e_company.png"} />
                    </div>
                    <div className={"circle"} id={"messenger"}>
                      <img src={"/media/6888bbe1f7031d6af06a9e68_industry.png"} />
                    </div>
                    <div className={"circle"} id={"notion"}>
                      <img src={"/media/6888bc11162b4e674e145e34_painpoint.png"} />
                    </div>
                  </div>
                  <div className={"center-icon"} id={"openai"}>
                    <img style={{ height: "40%" }} src={"/media/6888b9ef32771af91b4fa55c_singulate-icon-white.svg"} />
                  </div>
                  <div className={"right-icons"}>
                    <div className={"circle"} id={"user1"}>
                      <img src={"/media/6888c1155f36bdbdbb851229_hubspot.png"} />
                    </div>
                    <div className={"circle"} id={"user2"}>
                      <img src={"/media/6888c5c7f3f0583095ed671e_outreach.png"} />
                    </div>
                    <div className={"circle"} id={"user3"}>
                      <img src={"/media/6888c5e5eb590284413669a7_marketo.png"} />
                    </div>
                    <div className={"circle"} id={"user4"}>
                      <img src={"/media/6888c604c303c610c0882262_instantly.png"} />
                    </div>
                    <div className={"circle"} id={"user5"}>
                      <img src={"/media/6888c62466234f6e2fa59f65_zapier.png"} />
                    </div>
                  </div>
                </div>
              </div>
              <style>
                 /* Base layout */ body {"{"} margin: 0; font-family: sans-serif; background: white; {"}"} .beam-container {"{"} position: relative; width: 100%; aspect-ratio: 3 / 1; height: auto; {"}"} .beam-lines {"{"} position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none; {"}"} .beam-wrapper {"{"} position: relative; display: flex; justify-content: space-between; align-items: center; width: 100%; height: 100%; z-index: 1; {"}"} /* Icons on both sides */ .left-icons, .right-icons {"{"} display: flex; flex-direction: column; gap: 1.5rem; align-items: center; {"}"} .circle {"{"} height: auto; width: 150px; padding: 12px 0; border-radius: 12px; {"}"} .center-icon, .circle {"{"} background: #333343; box-shadow: 0 0 10px rgba(0,0,0,0.05); display: flex; align-items: center; justify-content: center; {"}"} .center-icon {"{"} height: 180px; width: 180px; border-radius: 200px; {"}"} .circle img, .center-icon img {"{"} max-width: 70%; max-height: 70%; {"}"} /* Beam lines */ .beam-path {"{"} stroke: rgba(255, 255, 255, 0.1); stroke-width: 1.2; fill: none; {"}"} .beam-segment {"{"} stroke-width: 2; fill: none; pointer-events: none; stroke-linecap: round; opacity: 0.4; {"}"} @keyframes beamMove {"{"} from {"{"} stroke-dashoffset: 0; {"}"} to {"{"} stroke-dashoffset: -1000; {"}"} {"}"} /* Mobile responsiveness */ @media (max-width: 768px) {"{"} .beam-wrapper {"{"} flex-direction: column; align-items: center; gap: 2rem; {"}"} .left-icons, .right-icons {"{"} flex-direction: row; flex-wrap: wrap; justify-content: center; gap: 1rem; {"}"} .beam-container {"{"} aspect-ratio: auto; height: auto; {"}"} {"}"} 
              </style>
            </div>
            <div className={"div-block-84"}>
              <div className={"w-layout-vflex flex-block-82"}>
                <h6 className={"mono-component-title white"}>
                  Data Platforms
                </h6>
                <p className={"small-text white nomargin"}>
                  Your CRM, CDP, Event Platform, CSVs
                </p>
              </div>
              <div className={"w-layout-vflex flex-block-80 center"}>
                <h6 className={"mono-component-title white"}>
                  MESSAGING Platform
                </h6>
                <p className={"nomargin white small-text maxwidthextrasmall center"}>
                  Create segmented and hyper-personalized messaging with data
                </p>
              </div>
              <div className={"w-layout-vflex flex-block-82 right"}>
                <h6 className={"mono-component-title white"}>
                  Delivery platforms
                </h6>
                <p className={"small-text white nomargin right"}>
                  Deliver through any outreach or automation channel
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"section-container section-padding-full gap-large hidden gray-background"}>
        <div className={"section-wrapper stack"}>
          <div className={"splide"}>
            <div className={"w-layout-hflex flex-block-77"}>
              <div className={"w-layout-vflex flex-block-75"}>
                <h3 className={"nomargin"}>
                  Helping teams send smarter
                </h3>
              </div>
            </div>
            <div className={"splide__arrows"}>
              <a href={"#"} className={"splide__arrow splide__arrow--prev w-button"} />
              <a href={"#"} className={"splide__arrow splide__arrow--next w-button"} />
            </div>
            <div className={"splide__track w-dyn-list"}>
              <div role={"list"} className={"splide__list w-dyn-items"}>
                <div role={"listitem"} className={"splide__slide light w-dyn-item"}>
                  <div className={"w-layout-vflex flex-block-76"}>
                    <img src={"/media/688632c0b220c0b7d416c3e3_anthrohub.png"} loading={"lazy"} alt="" className={"splide__image"} />
                    <h6 className={"quote"}>
                      I freakin’ love Singulate. I love helping my clients see better results and higher-intent click-throughs, and I love working inside the platform itself.
                    </h6>
                    <div className={"div-block-75"}>
                      <img src={"/media/6886328b044314a334720a7e_joe.jpg"} loading={"lazy"} alt="" className={"image-44"} />
                      <div className={"w-layout-vflex flex-block-78"}>
                        <div className={"text-block-40 mono-component-title"}>
                          Joe Cunningham
                        </div>
                        <div className={"small-text"}>
                          Founder & B2B Email Copywriter
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"w-layout-vflex"}>
                    <h2 data-text={"$11k"} className={"metric"}>
                      $11k
                    </h2>
                    <div className={"text-block-41"}>
                      in 24 hours for a client
                    </div>
                  </div>
                </div>
                <div role={"listitem"} className={"splide__slide light w-dyn-item"}>
                  <div className={"w-layout-vflex flex-block-76"}>
                    <img src={"/media/688631e70cd7e54403b7cab6_sustainabletimes.png"} loading={"lazy"} alt="" className={"splide__image"} />
                    <h6 className={"quote"}>
                      Singulate makes email messaging 10x more targeted. And it works seamlessly with HubSpot.
                    </h6>
                    <div className={"div-block-75"}>
                      <img src={"/media/688631c3114ee66a92aa4127_lorenzo.jpg"} loading={"lazy"} alt="" className={"image-44"} />
                      <div className={"w-layout-vflex flex-block-78"}>
                        <div className={"text-block-40 mono-component-title"}>
                          Lorenzo Liviero
                        </div>
                        <div className={"small-text"}>
                          Revenue Operations Manager
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"w-layout-vflex"}>
                    <h2 data-text={"2x"} className={"metric"}>
                      2x
                    </h2>
                    <div className={"text-block-41"}>
                      increase in click rates
                    </div>
                  </div>
                </div>
                <div role={"listitem"} className={"splide__slide light w-dyn-item"}>
                  <div className={"w-layout-vflex flex-block-76"}>
                    <img src={"/media/6886313ef2b041ebf8aca0bd_maestra.png"} loading={"lazy"} alt="" className={"splide__image"} />
                    <h6 className={"quote"}>
                      Now that I’ve used Singulate, when I’m in HubSpot I feel limited.
                    </h6>
                    <div className={"div-block-75"}>
                      <img src={"/media/6886310094529b78f78ae872_hunter.jpg"} loading={"lazy"} alt="" className={"image-44"} />
                      <div className={"w-layout-vflex flex-block-78"}>
                        <div className={"text-block-40 mono-component-title"}>
                          Hunter Flynn
                        </div>
                        <div className={"small-text"}>
                          CRM Automation Specialist
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"w-layout-vflex"}>
                    <h2 data-text={"2.5x"} className={"metric"}>
                      2.5x
                    </h2>
                    <div className={"text-block-41"}>
                      performance from automated nurtures
                    </div>
                  </div>
                </div>
                <div role={"listitem"} className={"splide__slide light w-dyn-item"}>
                  <div className={"w-layout-vflex flex-block-76"}>
                    <img src={"/media/688630acdce166d66c8688f0_leadr.png"} loading={"lazy"} alt="" className={"splide__image"} />
                    <h6 className={"quote"}>
                      Singulate leveraged our data unlike anything else, letting us be way more strategic and 10X more targeted in our personalized nurtures.
                    </h6>
                    <div className={"div-block-75"}>
                      <img src={"/media/688630833a1706e0f760314a_nick.jpg"} loading={"lazy"} alt="" className={"image-44"} />
                      <div className={"w-layout-vflex flex-block-78"}>
                        <div className={"text-block-40 mono-component-title"}>
                          Nick Ahrens
                        </div>
                        <div className={"small-text"}>
                          Head of Marketing
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"w-layout-vflex"}>
                    <h2 data-text={"54%"} className={"metric"}>
                      54%
                    </h2>
                    <div className={"text-block-41"}>
                      increase in responses
                    </div>
                  </div>
                </div>
                <div role={"listitem"} className={"splide__slide light w-dyn-item"}>
                  <div className={"w-layout-vflex flex-block-76"}>
                    <img src={"/media/6886300f96dfa3033ebe2c08_unifocus.png"} loading={"lazy"} alt="" className={"splide__image"} />
                    <h6 className={"quote"}>
                      Singulate makes messages feel truly one-to-one. Our SDR teams’ meetings booked have doubled using Singulate.
                    </h6>
                    <div className={"div-block-75"}>
                      <img src={"/media/68862fa3620916f9024de223_corey.jpg"} loading={"lazy"} alt="" className={"image-44"} />
                      <div className={"w-layout-vflex flex-block-78"}>
                        <div className={"text-block-40 mono-component-title"}>
                          Corey McCarthy
                        </div>
                        <div className={"small-text"}>
                          CMO
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"w-layout-vflex"}>
                    <h2 data-text={"35%"} className={"metric"}>
                      35%
                    </h2>
                    <div className={"text-block-41"}>
                      increase in click-through rates
                    </div>
                  </div>
                </div>
                <div role={"listitem"} className={"splide__slide light w-dyn-item"}>
                  <div className={"w-layout-vflex flex-block-76"}>
                    <img src={"/media/6886331757e8d7e2265b4ce2_workvivo.png"} loading={"lazy"} alt="" className={"splide__image"} />
                    <h6 className={"quote"}>
                      Two of our teams are running Singulate right now, and we’re seeing such standout results we’ve 15x’d our email volume, driven by how well the platform personalizes at scale.
                    </h6>
                    <div className={"div-block-75"}>
                      <img src={"/media/68862f5c1db5c9751bda1c6d_barry.jpg"} loading={"lazy"} alt="" className={"image-44"} />
                      <div className={"w-layout-vflex flex-block-78"}>
                        <div className={"text-block-40 mono-component-title"}>
                          Barry Nyhan
                        </div>
                        <div className={"small-text"}>
                          Head of Growth
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"w-layout-vflex"}>
                    <h2 data-text={"50%"} className={"metric"}>
                      50%
                    </h2>
                    <div className={"text-block-41"}>
                      increase in click rates
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"section-container section-padding-full"}>
        <div className={"section-wrapper stack center gap-large padding outline-card paddingbottom0"}>
          <h2 className={"center nomargin"}>
            Built for every customer journey
          </h2>
          <div data-current={"Tab 5"} data-easing={"ease"} data-duration-in={"300"} data-duration-out={"100"} className={"tabs-3 w-tabs"}>
            <div className={"tabs-menu-2 w-tab-menu"}>
              <a data-w-tab={"Tab 1"} className={"tab-link w-inline-block w-tab-link"}>
                <div className={"w-layout-vflex flex-block-86"}>
                  <img loading={"lazy"} src={"/media/688d0d7b4f842a3c088b2280_trendup.svg"} alt="" className={"image-52"} />
                  <div className={"text-block-43"}>
                    Marketing
                  </div>
                </div>
              </a>
              <a data-w-tab={"Tab 2"} className={"tab-link w-inline-block w-tab-link"}>
                <div className={"w-layout-vflex flex-block-86"}>
                  <img loading={"lazy"} src={"/media/688d1115015c1d3eece7f21c_handshake.svg"} alt="" className={"image-52"} />
                  <div className={"text-block-43"}>
                    Sales
                  </div>
                </div>
              </a>
              <a data-w-tab={"Tab 3"} className={"tab-link w-inline-block w-tab-link"}>
                <div className={"w-layout-vflex flex-block-86"}>
                  <img loading={"lazy"} src={"/media/688d11834619323e4d38e9f6_usersthree.svg"} alt="" className={"image-52"} />
                  <div className={"text-block-43"}>
                    Agencies
                  </div>
                </div>
              </a>
              <a data-w-tab={"Tab 4"} className={"tab-link w-inline-block w-tab-link"}>
                <div className={"w-layout-vflex flex-block-86"}>
                  <img loading={"lazy"} src={"/media/688d11ac5c7f771c67374fd5_rocket.svg"} alt="" className={"image-52"} />
                  <div className={"text-block-43"}>
                    Startups
                  </div>
                </div>
              </a>
              <a data-w-tab={"Tab 5"} className={"tab-link w-inline-block w-tab-link w--current"}>
                <div className={"w-layout-vflex flex-block-86"}>
                  <img loading={"lazy"} src={"/media/688d11e653e9149490aeb60b_calendar.svg"} alt="" className={"image-52"} />
                  <div className={"text-block-43"}>
                    Events
                  </div>
                </div>
              </a>
            </div>
            <div className={"tabs-content-2 w-tab-content"}>
              <div data-w-tab={"Tab 1"} className={"tab-pane w-tab-pane"}>
                <div className={"w-layout-hflex flex-block-85"}>
                  <div className={"w-layout-hflex _50 left gap"}>
                    <div className={"w-layout-vflex maxwidthsmall"}>
                      <h5>
                        Deliver relevance at scale
                      </h5>
                      <p className={"nomargin"}>
                        Singulate helps lifecycle marketers break free from static lists and one-size-fits-all journeys. Create dynamic segments on the fly using real-time CRM, event, and product data. Whether you’re activating leads, nurturing trials, or re-engaging users, Singulate makes it easy to personalize messages at every stage of the funnel.
                      </p>
                    </div>
                    <div className={"feature-list"}>
                      <div id={"w-node-_7e441bac-3d2f-ed45-46eb-b2bdcd4b03fe-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9c00dfd762791778765d_rows.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Build granular segments without SQL or filters
                        </p>
                      </div>
                      <div id={"w-node-_7e441bac-3d2f-ed45-46eb-b2bdcd4b0403-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9be2db79b0e72bb565b5_chat-centered.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Generate copy that adapts to each segment’s context
                        </p>
                      </div>
                      <div className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9bb6dd5073b862796e55_chat-teardrop-text.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Reactivate cold leads with content that lands
                        </p>
                      </div>
                    </div>
                    <Link to={"/lifecycle-marketing"} className={"button w-button"}>
                      Explore Lifecycle Marketing →
                    </Link>
                  </div>
                  <div className={"w-layout-hflex _50"}>
                    <img loading={"lazy"} src={"/media/688f7bfbd7ad08b66fb79a94_marketingemail.png"} alt="" className={"image-51"} />
                  </div>
                </div>
              </div>
              <div data-w-tab={"Tab 2"} className={"tab-pane w-tab-pane"}>
                <div className={"w-layout-hflex flex-block-85"}>
                  <div className={"w-layout-hflex _50 left gap"}>
                    <div className={"w-layout-vflex maxwidthsmall"}>
                      <h5>
                        More pipeline, less cold outreach
                      </h5>
                      <p className={"nomargin"}>
                        Sales teams can use Singulate to craft highly personalized follow-ups and outbound emails that actually get read. Leverage customer data and firmographics to generate compelling, contextual messages, without writing from scratch every time.
                      </p>
                    </div>
                    <div className={"feature-list"}>
                      <div id={"w-node-_0a19bbe0-b21c-7a48-96b2-3e7366097751-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9c00dfd762791778765d_rows.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Auto-generate 1:1 outreach from deal or CRM fields
                        </p>
                      </div>
                      <div id={"w-node-_0a19bbe0-b21c-7a48-96b2-3e7366097756-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9be2db79b0e72bb565b5_chat-centered.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Reactivate stale opportunities with fresh messaging
                        </p>
                      </div>
                      <div className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9bb6dd5073b862796e55_chat-teardrop-text.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Sync directly with your CRM and tools like HubSpot
                        </p>
                      </div>
                    </div>
                    <Link to={"/sales"} className={"button w-button"}>
                      Explore Sales →
                    </Link>
                  </div>
                  <div className={"w-layout-hflex _50"}>
                    <img loading={"lazy"} src={"/media/688f7c6bd217527a8db722fc_salesemail.png"} alt="" className={"image-51"} />
                  </div>
                </div>
              </div>
              <div data-w-tab={"Tab 3"} className={"tab-pane w-tab-pane"}>
                <div className={"w-layout-hflex flex-block-85"}>
                  <div className={"w-layout-hflex _50 left gap"}>
                    <div className={"w-layout-vflex maxwidthsmall"}>
                      <h5>
                        Scale personalization for your clients, without burning your team out.
                      </h5>
                      <p className={"nomargin"}>
                        Whether you manage multiple brands or complex workflows, Singulate gives agencies the power to create tailored messages fast. Segment smarter, personalize faster, and deliver performance that proves your value.
                      </p>
                    </div>
                    <div className={"feature-list"}>
                      <div id={"w-node-_267062bc-c39f-36ed-a5ef-659bc86750a6-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9c00dfd762791778765d_rows.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Support multiple client accounts from one workspace
                        </p>
                      </div>
                      <div id={"w-node-_267062bc-c39f-36ed-a5ef-659bc86750ab-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9be2db79b0e72bb565b5_chat-centered.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Customize email logic without technical overhead
                        </p>
                      </div>
                      <div className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9bb6dd5073b862796e55_chat-teardrop-text.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Reduce time-to-launch
                        </p>
                      </div>
                    </div>
                    <Link to={"/agencies"} className={"button w-button"}>
                      Explore Agency →
                    </Link>
                  </div>
                  <div className={"w-layout-hflex _50"}>
                    <img loading={"lazy"} src={"/media/688f7cd968bfe5b6f26d36e9_agencyemail2.png"} alt="" className={"image-51"} />
                  </div>
                </div>
              </div>
              <div data-w-tab={"Tab 4"} className={"tab-pane w-tab-pane"}>
                <div className={"w-layout-hflex flex-block-85"}>
                  <div className={"w-layout-hflex _50 left gap"}>
                    <div className={"w-layout-vflex maxwidthsmall"}>
                      <h5>
                        Ship faster. Talk smarter.
                      </h5>
                      <p className={"nomargin"}>
                        Startups use Singulate to punch above their weight. From product announcements to user onboarding, create high-performing emails that feel personal, without building a whole marketing ops team. Start with templates, then tweak as you grow.
                      </p>
                    </div>
                    <div className={"feature-list"}>
                      <div id={"w-node-_09dff276-b0a2-2b76-8b55-201df4ca43bd-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9c00dfd762791778765d_rows.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Convert leads during beta or launch
                        </p>
                      </div>
                      <div id={"w-node-_09dff276-b0a2-2b76-8b55-201df4ca43c2-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9be2db79b0e72bb565b5_chat-centered.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Personalize outreach without a CRM expert
                        </p>
                      </div>
                      <div className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9bb6dd5073b862796e55_chat-teardrop-text.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Scale lifecycle messaging without slowing down
                        </p>
                      </div>
                    </div>
                    <Link to={"/startups"} className={"button w-button"}>
                      Explore Startup →
                    </Link>
                  </div>
                  <div className={"w-layout-hflex _50"}>
                    <img loading={"lazy"} src={"/media/688f7d79183ff7b96aa45339_startupemail.png"} alt="" className={"image-51"} />
                  </div>
                </div>
              </div>
              <div data-w-tab={"Tab 5"} className={"tab-pane w-tab-pane w--tab-active"}>
                <div className={"w-layout-hflex flex-block-85"}>
                  <div className={"w-layout-hflex _50 left gap"}>
                    <div className={"w-layout-vflex maxwidthsmall"}>
                      <h5>
                        Make every attendee feel seen.
                      </h5>
                      <p className={"nomargin"}>
                        From webinars to conferences, Singulate helps you segment and message attendees based on behavior, role, and engagement level — before, during, and after the event. Drive attendance, engagement, and follow-ups with smarter targeting.
                      </p>
                    </div>
                    <div className={"feature-list"}>
                      <div id={"w-node-e7db6343-42d5-e10b-65a7-3fe7b8d76bc7-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9c00dfd762791778765d_rows.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Send tailored reminders and follow-ups
                        </p>
                      </div>
                      <div id={"w-node-e7db6343-42d5-e10b-65a7-3fe7b8d76bcc-9ecbfc76"} className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9be2db79b0e72bb565b5_chat-centered.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Highlight relevant sessions or tracks
                        </p>
                      </div>
                      <div className={"feature-list-item"}>
                        <div className={"icon-wrapper gray"}>
                          <img loading={"lazy"} src={"/media/67dd9bb6dd5073b862796e55_chat-teardrop-text.svg"} alt="" className={"feature-list-item-image"} />
                        </div>
                        <p className={"feature-list-item-text"}>
                          Turn attendees into pipeline, fast
                        </p>
                      </div>
                    </div>
                    <Link to={"/events"} className={"button w-button"}>
                      Explore Event Nurturing →
                    </Link>
                  </div>
                  <div className={"w-layout-hflex _50 marginnegativebottomsmall"}>
                    <img sizes={"(max-width: 900px) 100vw, 900px"} srcSet={"/media/688f7daef78e4789783cee40_eventsemail-p-500.png 500w, /media/688f7daef78e4789783cee40_eventsemail-p-800.png 800w, /media/688f7daef78e4789783cee40_eventsemail.png 900w"} alt="" src={"/media/688f7daef78e4789783cee40_eventsemail.png"} loading={"lazy"} className={"image-51"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={"section-container extrapaddingbottom"}>
        <div className={"section-wrapper gap"}>
          <div className={"_50 gap"}>
            <div className={"card row gray-background"}>
              <div className={"div-block-86"}>
                <img src={"/media/688a393dbe5af1470c97c0b8_hubpart.png"} loading={"lazy"} alt="" className={"image-49"} />
              </div>
              <div className={"w-layout-vflex flex-block-79"}>
                <h5 className={"nomargin"}>
                  Trusted HubSpot Partner
                </h5>
                <p className={"nomargin"}>
                  Ready to go in minutes, our integration works seamlessly with any campaign and workflow. View analytics right in HubSpot.
                </p>
              </div>
            </div>
            <div className={"card row gray-background"}>
              <div className={"div-block-86"}>
                <img src={"/media/68af488a63dcf1cf78d0a84a_soc2.png"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/68af488a63dcf1cf78d0a84a_soc2-p-500.png 500w, /media/68af488a63dcf1cf78d0a84a_soc2.png 600w"} alt="" className={"image-49"} />
              </div>
              <div className={"w-layout-vflex flex-block-79"}>
                <h5 className={"nomargin"}>
                  Built on best practices 
                </h5>
                <p className={"nomargin"}>
                  We partner with Vanta to meet the highest security standards, so your data stays protected.
                </p>
              </div>
            </div>
          </div>
          <div className={"_50"}>
            <div className={"card stretch gray-background"}>
              <div className={"w-layout-vflex header-text-wrap"}>
                <h5 className={"nomargin"}>
                  Connects where you work
                </h5>
                <p>
                  Plug into the tools you love and keep your flow while leveling up campaign performance.
                </p>
              </div>
              <img src={"/media/688a554a776b4d27b007e66f_integrationslist.png"} loading={"lazy"} sizes={"(max-width: 930px) 100vw, 930px"} srcSet={"/media/688a554a776b4d27b007e66f_integrationslist-p-500.png 500w, /media/688a554a776b4d27b007e66f_integrationslist-p-800.png 800w, /media/688a554a776b4d27b007e66f_integrationslist.png 930w"} alt="" />
            </div>
          </div>
        </div>
      </section>
      <BottomCTA />
      <div id={"ajaxContent"} style={{ display: "none" }} />
    </>
  )
}
